import Typography from '@mui/material/Typography';
import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation, useNavigate, usePostMessage } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { default as CrmZone } from '@swf/components/CrmZone/CrmZone';
import { CRMZone, PostMessage } from '@swf/core/enums';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import { select } from '@swf/core/store';

import Button from '../../../Button/Button';
import Container from '../../../Container/Container';
import Prompt from '../../../Prompt/Prompt';
import TransitionProgressPrompt from '../../../TransitionProgressPrompt/TransitionProgressPrompt';

import {
  TXTCLI_Almost_done,
  TXTCLI_Make_a_Deposit,
  TXTCLI_Once_you_depositX_youXll_be_go_ELL,
  TXTWCL_Almost_there,
  TXTWCL_Continue,
  TXTWCL_Continue_to_deposit,
  TXTWCL_Deposit_Now,
  TXTWCL_Make_your_first_deposit_and_cl_ELL,
  TXTWCL_Next_upXX,
  TXTWCL_YouXre_in
} from './SignupOffer.messages.json';
import { crm } from './SignupOffer.scss';

const SignupOffer: React.FunctionComponent = () => {
  const {
    data: { rmfPassed }
  } = useWizardContext();
  const navigate = useNavigate();
  const isES = useSelector(select.account.getLicense) === LicenceId.SPAIN;
  const site = useSelector(select.cms.getSiteId);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const swcDeposit = useFeature(FeatureFlag.SwcDeposit);
  const isSwcSignupRmfEcoEransitionTwo = useFeature(FeatureFlag.SwcSignupRmfEcoEransitionTwo);
  const isItaly = site === Sites.ITA;
  const isSports = useSelector(select.localSettings.getRegistrationBrand) === BrandTypes.BET_STARS;
  const hideTransition = isItaly && isSports;
  const postMessage = usePostMessage();
  const exitWizard = useWizardExit();

  const handleDepositClick = () => {
    if (!isEmbedded && !swcDeposit && window.opener) {
      postMessage(PostMessage.OPEN_DEPOSIT);
      exitWizard();
    } else {
      navigate('/account/cashier/deposit');
    }
  };

  return (
    <Container
      page={SignupOffer}
      headerProps={{
        title: <Translation {...TXTWCL_YouXre_in} />,
        buttons: {}
      }}
    >
      {![Sites.UK].includes(site) &&
        rmfPassed &&
        !isSwcSignupRmfEcoEransitionTwo &&
        !hideTransition && (
          <Prompt
            title={{ translation: TXTWCL_Almost_there }}
            secondaryTitle={{ translation: TXTWCL_Next_upXX }}
            primaryButton={{
              translation: TXTWCL_Continue
            }}
            onPrimaryButtonClick={() => navigate('/account/cashier/deposit')}
            noCloseButton
            variant="celebration"
          >
            <Typography>
              <Translation {...TXTWCL_Make_your_first_deposit_and_cl_ELL} />
            </Typography>
          </Prompt>
        )}
      {![Sites.UK].includes(site) &&
        rmfPassed &&
        isSwcSignupRmfEcoEransitionTwo &&
        !hideTransition && (
          <TransitionProgressPrompt
            title={{ translation: TXTCLI_Almost_done }}
            primaryButton={{ translation: TXTWCL_Continue_to_deposit }}
            onPrimaryButtonClick={() => navigate('/account/cashier/deposit')}
          >
            <Typography>
              <Translation {...TXTCLI_Once_you_depositX_youXll_be_go_ELL} />
            </Typography>
          </TransitionProgressPrompt>
        )}
      <div className={crm}>
        <CrmZone zoneId={CRMZone.SWC_TRANSITION_TO_WC2} componentType="Single" dynamicHeight />
      </div>
      <Button
        translation={isES ? TXTCLI_Make_a_Deposit : TXTWCL_Deposit_Now}
        onClick={handleDepositClick}
      />
    </Container>
  );
};

SignupOffer.displayName = 'SignupOffer';

export default SignupOffer;
